import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { HomepageModalType } from "../HomepageModalType.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = sameValueForEveryLocale("/");

export function getHomepagePath(tenant: Tenant, modal?: HomepageModalType): string {
	const pathBase = getPathInLocale(tenant.locale, pathMap);
	if (modal === undefined) {
		return pathBase;
	}
	return `${pathBase}?modal=${modal}`;
}
